'use strict';

import BookingSuggestion from './booking_suggestion';
import Conversation from './conversation';
import Trip from './trip';
import Guide from './guide';
import Message from './message';
import User from './user';

export default angular
  .module('resources', [])
  .service('bookingSuggestionResource', BookingSuggestion)
  .factory('Conversation', Conversation)
  .factory('Trip', Trip)
  .factory('Guide', Guide)
  .factory('Message', Message)
  .service('userResource', User)
  .name;



// WEBPACK FOOTER //
// ./app/src/resources/index.js